/* ============================================================
   article.js — article page interactions.
     - Auto-generated TOC from h2/h3 in article body
     - Active-section highlighting on scroll
     - "Copy link" share button
     - blog_card_click: every card, CTA and bar in an article carries
       data-blog-card (its kind) and data-blog-card-handle. A click on a
       link or the Add to basket button inside one is published to
       Shopify's customer events (Shopify.analytics.publish, so a custom
       pixel can forward it to GA4), pushed to dataLayer when GTM is on the
       page, and fired on document.
   ============================================================ */
(function () {
  'use strict';

  function slugify(text) {
    return text.toLowerCase()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 80);
  }

  function initToc() {
    var article = document.querySelector('[data-article-body]');
    var tocNav = document.querySelector('[data-toc]');
    var tocList = document.querySelector('[data-toc-list]');
    if (!article || !tocNav || !tocList) return;

    /* Card titles (in-article product / collection cards, the recommended
       products strip) are h3s too, but they are not sections of the
       article, so they stay out of the contents list. */
    var headings = Array.prototype.filter.call(article.querySelectorAll('h2, h3'), function (h) {
      return !h.closest('[data-toc-skip], .article-embed-card, .product-card');
    });
    if (headings.length < 2) {
      tocNav.setAttribute('hidden', '');
      return;
    }

    var seen = {};
    var items = [];
    headings.forEach(function (h) {
      if (!h.id) {
        var base = slugify(h.textContent);
        var id = base;
        var n = 2;
        while (seen[id]) { id = base + '-' + n; n++; }
        seen[id] = true;
        h.id = id;
      }
      items.push(h);
    });

    items.forEach(function (h) {
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      a.className = 'toc-card__item toc-card__item--' + h.tagName.toLowerCase();
      a.setAttribute('data-toc-link', h.id);
      tocList.appendChild(a);
    });

    /* Reveal once populated */
    tocNav.removeAttribute('hidden');

    /* Active highlight */
    var links = {};
    tocList.querySelectorAll('[data-toc-link]').forEach(function (a) {
      links[a.getAttribute('data-toc-link')] = a;
    });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var link = links[e.target.id];
        if (!link) return;
        if (e.isIntersecting) {
          Object.keys(links).forEach(function (id) { links[id].classList.remove('is-active'); });
          link.classList.add('is-active');
        }
      });
    }, { rootMargin: '-30% 0px -55% 0px', threshold: 0 });
    items.forEach(function (h) { observer.observe(h); });
  }

  function initShare() {
    var btn = document.querySelector('[data-share-copy]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (!navigator.clipboard) return;
      navigator.clipboard.writeText(window.location.href).then(function () {
        var sr = document.createElement('span');
        sr.className = 'visually-hidden';
        sr.textContent = 'Link copied to clipboard';
        document.body.appendChild(sr);
        btn.setAttribute('aria-label', 'Link copied ✓');
        setTimeout(function () {
          btn.setAttribute('aria-label', 'Copy link');
          sr.remove();
        }, 2000);
      });
    });
  }

  function initCardTracking() {
    var body = document.querySelector('[data-article-body]');
    var articleHandle = body ? body.getAttribute('data-article-handle') || '' : '';
    document.addEventListener('click', function (e) {
      var el = e.target.closest ? e.target.closest('a[href], button[type="submit"]') : null;
      if (!el) return;
      var card = el.closest('[data-blog-card]');
      if (!card) return;
      var href = el.getAttribute('href') || (el.form ? el.form.getAttribute('action') : '') || '';
      var target = href.match(/\/(products|collections|pages|blogs)\/([^\/?#]+)/) || [];
      var detail = {
        article: articleHandle,
        card: card.getAttribute('data-blog-card') || '',
        handle: card.getAttribute('data-blog-card-handle') || '',
        action: el.tagName === 'BUTTON' ? 'add_to_basket' : 'click',
        target_type: target[1] || '',
        target_handle: target[2] || ''
      };
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('blog_card_click', detail);
        }
      } catch (err) { /* noop */ }
      if (Array.isArray(window.dataLayer)) {
        var pushed = { event: 'blog_card_click' };
        for (var k in detail) pushed[k] = detail[k];
        window.dataLayer.push(pushed);
      }
      document.dispatchEvent(new CustomEvent('blog_card_click', { detail: detail }));
    });
  }

  function init() {
    initToc();
    initShare();
    initCardTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
